import { Link, useParams } from "react-router-dom";
// import logo from "../assets/images/CA-logo.png";
import "../../../assets/css/CACard.css";
import logo from "../../../assets/images/CA-logo.png";
import userAvatar from "../../../assets/images/avatar2.jpg";
import whatsapplogo from "../../../assets/images/whatsapp-logo.png";
import phonelogo from "../../../assets/images/phone-logo.png";
import { useEffect, useState } from "react";
import { getCAICAICardApi } from "../../../services/apis/CACardServiceApi";
import apis from "../../../services/apis";
import { Toaster, ToasterContainer } from "../../components/Toaster/Toster";
import DodLogo from "../../../assets/images/dod_logo2.png";


// Non ICAI CARD Import
// import apis from "../../../services/apis";
import "../../../assets/css/UserProfile.css";
// import { getUserProfileApi } from "../../../services/apis/UserProfile";
import { FaFacebookF, FaGlobe, FaInstagram, FaLinkedinIn, FaSkype, FaSnapchatGhost, FaTelegramPlane, FaTwitter, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { MdEdit, MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa"
import { BsLink45Deg } from "react-icons/bs";
// import userAvatar from "../../../assets/images/avatar2.jpg";
import triImg from "../../../assets/images/FullLogo_Transparent.png";
// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserDataAction } from "../../../store/actions/UserAction";
// import { Toaster } from "../../components/Toaster/Toster";
import { getUserProfileApi } from "../../../services/apis/UserProfile";
import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";

import websiteImg from "../../../assets/images/social-icon/website.jpg";
import catalogueImg from "../../../assets/images/social-icon/catelog.jpg";
import emailImg from "../../../assets/images/social-icon/email.jpg";
import whatsAppImg from "../../../assets/images/social-icon/whatsapp.jpg";
import instagramImg from "../../../assets/images/social-icon/instagram.jpg";
import linkedinImg from "../../../assets/images/social-icon/linkedin.png";
import phoneImg from "../../../assets/images/social-icon/phone.jpg";
import youtubeImg from "../../../assets/images/social-icon/youtube.png";
import messageImg from "../../../assets/images/social-icon/message.jpg";
import kakaotalkImg from "../../../assets/images/social-icon/kakaotalk.jpg";
import skypeImg from "../../../assets/images/social-icon/skype.jpg";
import locationImg from "../../../assets/images/social-icon/location.jpg";
import wechatImg from "../../../assets/images/social-icon/wechat.jpg";
import calendlyImg from "../../../assets/images/social-icon/calendly.jpg";
import twitchImg from "../../../assets/images/social-icon/twitch.jpg";
import telegramImg from "../../../assets/images/social-icon/telegram.jpg";
import snapchatImg from "../../../assets/images/social-icon/snapchat.jpg";
import tiktokImg from "../../../assets/images/social-icon/tiktok.jpg";
import pinterestImg from "../../../assets/images/social-icon/pintrest.jpg";
import twitterImg from "../../../assets/images/social-icon/twitter.jpg";
import facebookImg from "../../../assets/images/social-icon/facebook.png";
import trustpilotImg from "../../../assets/images/social-icon/trustpilot.jpg";
import tripadvisorImg from "../../../assets/images/social-icon/Tripadvisor.png";
import videoImg from "../../../assets/images/social-icon/video.jpg";
import imageImg from "../../../assets/images/social-icon/image.jpg";
import pdfImg from "../../../assets/images/social-icon/pdf.jpg";
import slackImg from "../../../assets/images/social-icon/slack.jpg";
import menuImg from "../../../assets/images/social-icon/menu.jpg";
import discordImg from "../../../assets/images/social-icon/discord.jpg";
import spotifyImg from "../../../assets/images/social-icon/spotify.jpg";
import paypalImg from "../../../assets/images/social-icon/paypal.jpg";
import playstoreImg from "../../../assets/images/social-icon/playstore.jpg";
import appstoreImg from "../../../assets/images/social-icon/appstore.jpg";
import mediumImg from "../../../assets/images/social-icon/medium.jpg";
import behanceImg from "../../../assets/images/social-icon/behance.jpg";
import amazonImg from "../../../assets/images/social-icon/amazon.jpg";
import flipkartImg from "../../../assets/images/social-icon/flipkart.jpg";
import myntraImg from "../../../assets/images/social-icon/myntra.jpg";
import bookingImg from "../../../assets/images/social-icon/booking.jpg";
import facetimeImg from "../../../assets/images/social-icon/facetime.jpg";
import goibiboImg from "../../../assets/images/social-icon/goibibo.jpg";
import googleRatingImg from "../../../assets/images/social-icon/google rating.jpg";
import humanitixImg from "../../../assets/images/social-icon/humanitix.jpg";
import makemytripImg from "../../../assets/images/social-icon/makemytrip.jpg";
import meetupImg from "../../../assets/images/social-icon/meetup.jpg";
import onlyfansImg from "../../../assets/images/social-icon/only fans.jpg";
import openseaImg from "../../../assets/images/social-icon/open sea.jpg";
import swiggyImg from "../../../assets/images/social-icon/swiggy.jpg";
import zomatoImg from "../../../assets/images/social-icon/zomato.jpg";
import ticketmasterImg from "../../../assets/images/social-icon/ticket master.jpg";
import ubereatsImg from "../../../assets/images/social-icon/uber eats.jpg";
import eatclubImg from "../../../assets/images/social-icon/eatclub.png";
import whatsAppbusinessImg from "../../../assets/images/social-icon/whatsApp bus.jpg";
import lumaImg from "../../../assets/images/social-icon/luma.jpg";
import sortmysceneImg from "../../../assets/images/social-icon/sortmyscene.png";
import paytminsiderImg from "../../../assets/images/social-icon/paytm insider.png";
import bookmyshowImg from "../../../assets/images/social-icon/BookMyShow.jpg";
import stripeImg from "../../../assets/images/social-icon/stripe.jpg";
import cryptowalletImg from "../../../assets/images/social-icon/crypto wallet.png";
import AddContactIcon from "../../../assets/images/social-icon/add-user.png"

import { IoPersonAddSharp } from "react-icons/io5";

const iconMap = {
  website: websiteImg,
  catalogue: catalogueImg,
  email: emailImg,
  whatsapp: whatsAppImg,
  instagram: instagramImg,
  linkedin: linkedinImg,
  phone: phoneImg,
  youtube: youtubeImg,
  message: messageImg,
  kakaotalk: kakaotalkImg,
  skype: skypeImg,
  location: locationImg,
  wechat: wechatImg,
  calendly: calendlyImg,
  twitch: twitchImg,
  telegram: telegramImg,
  snapchat: snapchatImg,
  tiktok: tiktokImg,
  pinterest: pinterestImg,
  twitter: twitterImg,
  facebook: facebookImg,
  trustpilot: trustpilotImg,
  tripadvisor: tripadvisorImg,
  video: videoImg,
  image: imageImg,
  pdf: pdfImg,
  slack: slackImg,
  menu: menuImg,
  discord: discordImg,
  spotify: spotifyImg,
  paypal: paypalImg,
  playstore: playstoreImg,
  appstore: appstoreImg,
  medium: mediumImg,
  behance: behanceImg,
  amazon: amazonImg,
  flipkart: flipkartImg,
  myntra: myntraImg,
  booking: bookingImg,
  facetime: facetimeImg,
  goibibo: goibiboImg,
  google_reviews: googleRatingImg,
  humanitix: humanitixImg,
  make_my_trip: makemytripImg,
  meetup: meetupImg,
  only_fans: onlyfansImg,
  open_sea: openseaImg,
  swiggy: swiggyImg,
  zomato: zomatoImg,
  ticketmaster: ticketmasterImg,
  uber_eats: ubereatsImg,
  eatclub: eatclubImg,
  wa_business: whatsAppbusinessImg,
  luma: lumaImg,
  sort_my_scene: sortmysceneImg,
  paytm_insider: paytminsiderImg,
  book_my_show: bookmyshowImg,
  stripe: stripeImg,
  crypto_wallet: cryptowalletImg,
  business_phone: phoneImg,
  business_email: emailImg,
  whatsapp_group: whatsAppImg,
  facebook_group: facebookImg,
  app_store: appstoreImg,
  play_store: playstoreImg,
  whatsApp: whatsAppImg
};

const CACard = () => {
  const id = useParams()?.id;
  const [u_Data, setUserData] = useState({});
  // console.log("idddd",id)
  const imgBaseUrl = apis?.baseurl?.Baseimageurl;

  const dispatch = useDispatch();
  // const imgBaseUrl = apis?.baseurl?.Baseimageurl;
  const user = useSelector((val) => val?.userReducers?.user);

  const [filteredData, setFilteredData] = useState([]);




  const getUserInfo = async () => {
    try {
      const res = await getCAICAICardApi(id);
      const userData = res?.data?.data;

      if (userData?.social_media_links) {
        const newlinksdata = JSON.parse(userData.social_media_links);
        const uniqueData = {};

        Object.values(newlinksdata).forEach((section) => {
          Object.entries(section).forEach(([key, value]) => {
            if (value.url && !uniqueData[key]) { // Ensure unique keys with valid URLs
              uniqueData[key] = value;
            }
          });
        });

        const finalArray = Object.entries(uniqueData).map(([key, value]) => ({
          key,
          ...value
        }));
        setFilteredData(finalArray);
      }


      // if (userData?.social_media_links) {
      //   const newlinksdata = JSON.parse(userData.social_media_links);
      //   const result = {};
      //   Object?.keys(newlinksdata)?.forEach((section) => {
      //     const filteredSection = Object?.entries(newlinksdata[section])?.reduce((acc, [key, value]) => {
      //       if (value.url) acc[key] = value;
      //       return acc;
      //     }, {});

      //     if (Object.keys(filteredSection).length > 0) {
      //       result[section] = filteredSection;
      //     }
      //   });

      //   setFilteredData(result)
      // }

      setUserData(userData);
    } catch (err) {
      //  console.log(err?.response?.data?.message);
      Toaster.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (id && id !== "login") {
      getUserInfo();
    }
  }, [id]);

  const handleDownloadvcfFile = () => {
    const contactName = u_Data?.member_name || "Unnamed";
    const contactNumber = u_Data?.mobile || "";
    const contactEmail = u_Data?.email || "";
    const base64Image = `data:image/jpeg;base64,${u_Data?.profile_image}`;

    const getURLByKey = (key) => {
      const item = filteredData.find((item) => item.key === key);
      return item ? item.url : null;
    };

    const websiteURL = getURLByKey('website');
    const catalogueURL = getURLByKey('catalogue');
    const instagramURL = getURLByKey('instagram');
    const facebookURL = getURLByKey('facebook');


    // const vCardData = [
    //   "BEGIN:VCARD",
    //   "VERSION:3.0",
    //   `N:;${contactName};;;`,
    //   `FN:${contactName}`,
    //   `TEL;TYPE=CELL:${contactNumber}`,
    //   `PHOTO;ENCODING=b;TYPE=JPEG:${base64Image}`,
    //   "END:VCARD",
    // ].join("\r\n");

    const vCardData = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:;${contactName};;;`,
      `FN:${contactName}`,
      `TEL;TYPE=CELL:${contactNumber}`,
      `EMAIL:${contactEmail}`,                   // Email
      `URL;TYPE=website:${websiteURL}`,         // Website
      `URL;TYPE=catalogue:${catalogueURL}`,     // Catalogue URL
      `X-FACEBOOK:${facebookURL}`,              // Facebook
      `X-INSTAGRAM:${instagramURL}`,            // Instagram
      `PHOTO;ENCODING=b;TYPE=JPEG:${base64Image}`,
      "END:VCARD",
    ].join("\r\n");


    const blob = new Blob([vCardData], { type: "text/x-vcard" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${contactName.replace(" ", "_")}.vcf`;
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const ensureAbsoluteUrl = (url) => {
    if (/^(https?:\/\/|mailto:|tel:)/.test(url)) {
      return url; // If it already has a valid scheme, return as is
    }
    return `https://${url}`; // Prefix with https:// if it's missing
  };


  // Non ICAI CARD DATA


  const getUsersInfo = async () => {
    try {
      const response = await getUserProfileApi();
      const uData = response?.data?.data;
      // console.log("response", uData);


      dispatch(UserDataAction(uData));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUsersInfo();
  }, []);

  const handleClick = (e, link) => {
    if (!link || link.trim() === "") {
      e.preventDefault(); // Prevent navigation
      Toaster.warning("Link is not available."); // Optional: Show notification or message
    }
  };

  const phoneNumber = user?.whatsapp_number
    ? user?.whatsapp_number
    : user?.mobile;
  // const message = "Hello, I need help!";

  const {
    member_name,
    company_name,
    designation,
    business_card_url,
    profile_image,
  } = u_Data;

  // Construct the WhatsApp message
  const message = `Hi! Check out this profile:
- Name: ${member_name}
- Company: ${company_name}
- Designation: ${designation}
- Business Card: ${business_card_url}
${profile_image ? `- Profile Image: ${profile_image}` : ""}`;

  // console.log( "check",Object.keys(u_Data).length !== 0)
  // console.log("chhhcc",u_Data?.whatsapp_business_number?.toString()?.length)

  let content;
  if (u_Data?.user_type === "ICAI") {
    content = (
      <div className="ca-card-maindiv pt-0 pt-md-4">
        <div className="d-flex justify-content-center">
          <div className="ca-card-main-div">
            <div>
              <img className="logo-img" src={logo} alt="logo" />
            </div>

            <div className="pt-3">
              <div className="d-flex flex-column align-items-center gap-2 gap-xl-3 user-info-div">
                <div>
                  <img
                    className="user-profile-img"
                    src={
                      u_Data?.profile_image
                        ? `${imgBaseUrl}${u_Data?.profile_image}`
                        : userAvatar
                    }
                    alt="user-profile"
                  />
                </div>
                <h3 className="user-name-text font-semibold text-white text-center mb-0">
                  {u_Data?.member_name}
                </h3>
                <h3 className="text-xl font-semibold text-white text-center m-0">
                  {u_Data?.mobile}
                </h3>
                <div>
                  <button
                    className="save-to-phone-btn"
                    onClick={handleDownloadvcfFile}>
                    Save To Phone
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex gap-3 pt-4">
                <a
                  href={`https://api.whatsapp.com/send?phone=${u_Data?.whatsapp_number
                    ? u_Data?.whatsapp_number
                    : u_Data?.mobile
                    }`}
                  target="_blank">
                  <img
                    className="whatsapp-logo"
                    src={whatsapplogo}
                    alt="logo1"
                  />
                </a>
                <a href={`tel:${u_Data?.mobile}`} target="_blank">
                  <img className="whatsapp-logo" src={phonelogo} alt="logo2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (u_Data?.user_type === "Non-ICAI") {
    content = (
      <div className="profile-backgroud position-relative">
        <div className="container-md-fluid usr-nonca-card">
          <div className="background-profile-blur-div d-flex flex-column align-items-center">
            <div className="d-flex flex-column align-items-center gap-2 position-relative w-100">
              <div className="w-100">
                {u_Data?.cover_image &&
                  <img
                    className="cover-img"
                    src={
                      u_Data?.cover_image
                        ? `${imgBaseUrl}${u_Data?.cover_image}`
                        : ""
                    }
                    alt="cover_img"
                  />
                }
              </div>
              <div className="mt-2 mt-md-4">
                <img
                  className={u_Data?.cover_image ? "UserProfile-img" : "UserProfile-img mt-5"}
                  src={
                    u_Data?.profile_image
                      ? `${imgBaseUrl}${u_Data?.profile_image}`
                      : userAvatar
                  }
                  alt="profile_img"
                />
              </div>

              <div className=""
                style={{
                  position: 'absolute', top: '75%',
                  right: '2%',
                }}>

                <button
                  onClick={handleDownloadvcfFile}
                  style={{
                    padding: '7px 10px', backgroundColor: '#f37b1c',
                    fontWeight: "500",
                    color: 'white', border: 'none', borderRadius: '14px'
                  }}><IoPersonAddSharp size={15} /> Add</button>
              </div>
            </div>

            <div className="text-center mt-2 mt-md-4 px-1">
              {/* <div className="d-flex gap-2 align-items-center justify-content-center"> */}
              <h3 className="username-text text-capitalize m-0">
                {u_Data?.member_name}
              </h3>
              {/* <div>
                  <img
                    src={AddContactIcon}
                    className="cursor-pointer"
                    onClick={handleDownloadvcfFile}
                    height='40px'
                    width='40px'
                  />
                </div>
              </div> */}
              <p className="user-info-text mb-0">{u_Data?.designation} {(u_Data?.designation && u_Data?.company_name) && '@'} {u_Data?.company_name} </p>
            </div>

            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 px-1">
              {/* <p className="user-info-text2 m-0">{u_Data?.company_name}</p>
              {(u_Data?.company_name && u_Data?.industry) &&
                <div className="center-line d-none d-md-block"></div>} */}
              <p className="user-info-text2 m-0">{u_Data?.industry}</p>
            </div>

            <div className="px-1">
              <p className="user-info-text2">{u_Data?.google_address}</p>
            </div>

            <div className="d-flex flex-column flex-md-row gap-2 px-3">
              <div className="d-flex justify-content-center  gap-2 ga-md-3">
                {
                  u_Data?.email &&
                  <a
                    className="social-btn d-flex align-items-center justify-content-left gap-2"
                    // href={u_Data?.email}
                    href={`https://mail.google.com/mail/?view=cm&to=${u_Data?.email}&subject=Hello%20There&body=I%20wanted%20to%20discuss%20an%20opportunity`}
                    target="_blank" >
                    <MdEmail size={20} />
                    Email
                  </a>
                }

                <a
                  className="social-btn d-flex align-items-center justify-content-left gap-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`tel:${u_Data?.mobile}`}
                >
                  <FaPhoneAlt size={17} /> Phone
                </a>
              </div>

              <div className="d-flex justify-content-center mt-sm-0 gap-2 ga-md-3">
                <a
                  className="social-btn d-flex align-items-center justify-content-left gap-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://api.whatsapp.com/send?phone=${u_Data?.whatsapp_number
                    ? u_Data?.whatsapp_number
                    : u_Data?.mobile
                    }`}>
                  <FaWhatsapp size={20} /> WhatsApp
                </a>
                {
                  u_Data?.whatsapp_business_number && u_Data?.whatsapp_business_number?.toString()?.length > 2 &&
                  <a
                    className="social-btn d-flex align-items-center justify-content-left gap-2"
                    href={u_Data?.whatsapp_business_number ? `https://wa.me/${u_Data?.whatsapp_business_number}` : "#"}
                    target="_blank"
                    rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" height={22} viewBox="0 0 32 32" id="WhatsappBusiness">
                      <path d="M17 4C10.383 4 5 9.383 5 16c0 2.003.503 3.974 1.473 5.754l-2.33 5.827a.999.999 0 0 0 1.3 1.299l5.837-2.335A11.948 11.948 0 0 0 17 28c6.617 0 12-5.383 12-12S23.617 4 17 4zm0 22a9.962 9.962 0 0 1-5.135-1.423.998.998 0 0 0-.906-.063l-4.094 1.644 1.522-3.808.109-.241a1.004 1.004 0 0 0-.009-.844 2.041 2.041 0 0 0-.103-.19A9.995 9.995 0 0 1 7 16c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10zm4.664-12.811C21.509 11.401 19.898 10 18 10h-4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4c1.898 0 3.509-1.401 3.664-3.189a3.516 3.516 0 0 0-1.037-2.81 3.522 3.522 0 0 0 1.037-2.812zM18 20h-3v-3h3.178c.426 0 .818.173 1.106.487.287.313.425.722.388 1.15C19.606 19.389 18.856 20 18 20zm1.284-5.487c-.288.314-.68.487-1.106.487H15v-3h3c.856 0 1.606.611 1.672 1.363.037.428-.101.837-.388 1.15z" fill="#ffffff" class="color000000 svgShape"></path>
                    </svg>
                    WA Business
                  </a>
                }
              </div>
            </div>

            {/* <div className="mt-0 mt-md-3">
              <ul className="wrapper">
                <a
                  href={u_Data?.facebook_link || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`d-flex align-items-center gap-2 ${
                    u_Data?.facebook_link ? "" : "d-none"
                  } `}>
                  <li className="icon facebook">
                    <span className="tooltip">Facebook</span>
                    <FaFacebookF />
                  </li>
                </a>

                <a
                  href={u_Data?.instagram_link || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`d-flex align-items-center gap-2 ${
                    u_Data?.instagram_link ? "" : "d-none"
                  } `}>
                  <li className="icon instagram">
                    <span className="tooltip">Instagram</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="1.2em"
                      fill="currentColor"
                      className="bi bi-instagram"
                      viewBox="0 0 16 16">
                      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"></path>
                    </svg>
                  </li>
                </a>

                <a
                  href={u_Data?.website || ""}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`d-flex align-items-center gap-2 ${
                    u_Data?.website ? "" : "d-none"
                  } `}>
                  <li className="icon website">
                    <span className="tooltip">Website</span>
                    <svg
                      height="1.8em"
                      fill="currentColor"
                      viewBox="0 0 48 48"
                      xmlns="http://www.w3.org/2000/svg"
                      className="website">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        className="c-icon c-icon--md"
                        role="presentation"
                        data-v-f03d3c87="">
                        <path
                          d="M8 15c1.9382 0 3.5894-.6821 4.9536-2.0464C14.318 11.5894 15 9.9382 15 8c0-1.9382-.6821-3.5894-2.0464-4.9536C11.5894 1.682 9.9382 1 8 1c-1.9382 0-3.594.6868-4.9677 2.0605C1.6774 4.4153 1 6.0618 1 8c0 1.9382.6821 3.5894 2.0464 4.9536C4.4106 14.318 6.0618 15 8 15zm1.7782-9.4839H6.2218c.1881-.9408.461-1.703.8185-2.2863.3575-.5833.6774-.875.9597-.875s.6022.2917.9597.875c.3575.5834.6304 1.3455.8185 2.2863zm3.2742 0h-1.8911c-.1882-1.035-.4798-1.9287-.875-2.6814 1.242.5645 2.164 1.4583 2.7661 2.6814zm-8.2137 0H2.9476c.6021-1.223 1.5242-2.117 2.7661-2.6814-.3952.7527-.6868 1.6465-.875 2.6814zm-.1693 3.613H2.4677A5.744 5.744 0 012.3548 8c0-.3763.0377-.7527.113-1.129h2.2016c-.0377.414-.0565.7903-.0565 1.129s.0188.715.0565 1.129zm5.3064 0H6.0242C5.9866 8.715 5.9677 8.3386 5.9677 8s.0189-.715.0565-1.129h3.9516c.0376.414.0565.7903.0565 1.129 0 .3199-.0189.6962-.0565 1.129zm3.5565 0h-2.2017c.0377-.414.0565-.7904.0565-1.1291s-.0188-.715-.0565-1.129h2.2017A5.744 5.744 0 0113.6452 8a5.744 5.744 0 01-.113 1.129zm-7.8186 4.0362a6.1783 6.1783 0 01-1.623-1.1008c-.4798-.4516-.8609-.9785-1.1431-1.5806h1.8911c.1882 1.035.4798 1.9287.875 2.6814zM8 13.6452c-.2823 0-.6022-.2917-.9597-.875-.3575-.5834-.6304-1.3455-.8185-2.2863h3.5564c-.1881.9408-.461 1.703-.8185 2.2863-.3575.5833-.6774.875-.9597.875zm2.2863-.4799c.3952-.7527.6868-1.6465.875-2.6814h1.8911c-.6021 1.223-1.5242 2.117-2.7661 2.6814z"
                          fill-rule="nonzero"
                          data-v-f03d3c87=""
                        ></path>
                      </svg>
                    </svg>
                  </li>
                </a>
              </ul>
            </div> */}

            {/* <div className="mt-0 mt-md-3 d-flex justify-content-center">
              <ul className="wrapper d-grid gap-3" style={{
                gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
                justifyContent: "center",
                maxWidth: "600px" // Adjust based on the design 
              }}>
                {[
                  { name: "Facebook", link: u_Data?.facebook_link, icon: <FaFacebookF />, class: "facebook" },
                  { name: "Instagram", link: u_Data?.instagram_link, icon: <FaInstagram />, class: "instagram" },
                  { name: "LinkedIn", link: u_Data?.linkedin_link, icon: <FaLinkedinIn />, class: "linkedin" },
                  { name: "YouTube", link: u_Data?.youtube, icon: <FaYoutube />, class: "youtube" },
                  { name: "Twitter", link: u_Data?.twitter_link, icon: <FaTwitter />, class: "twitter" },
                  { name: "Snapchat", link: u_Data?.snapchat_link, icon: <FaSnapchatGhost />, class: "snapchat" },
                  { name: "Skype", link: u_Data?.skype_id, icon: <FaSkype />, class: "skype" },
                  { name: "Telegram", link: u_Data?.telegram_link, icon: <FaTelegramPlane />, class: "telegram" },
                  { name: "Website", link: u_Data?.website, icon: <FaGlobe />, class: "website" },
                ]?.map((item, index) => (
                  item?.link && (
                    <a key={index}
                      href={item.link || "#"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center justify-content-center">
                      <li className={`icon ${item.class}`}>
                        <span className="tooltip">{item.name}</span>
                        {item.icon}
                      </li>
                    </a>
                  )
                ))}
              </ul>
            </div> */}

            {/* <div className="mt-0 mt-md-3 d-flex justify-content-center">
              <div className="social-link-main-div mt-4">
                {Object?.entries(filteredData)?.map(([sectionName, items]) => (
                  <div key={sectionName} className="section-social-media-links ">
                    <h6>{sectionName.replace(/([A-Z])/g, " $1").toUpperCase()}</h6>
                    <div className="sl-social-media-grid">
                      {Object?.entries(items)?.map(([key, value]) => (

                        <div key={key} className="sl-social-media-item">
                          <img
                            src={iconMap[key] || websiteImg}
                            alt={key}
                            className="sl-social-icon"
                          />
                          <a href="" target="_blank" rel="noopener noreferrer">
                            {value.name || key}
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            <div className="mt-0 mt-md-3 px-3 d-flex justify-content-center">
              <div className="social-link-main-div mt-4">
                <div className="sl-social-media-grid">
                  {/* {filteredData?.map((item) => (
                    <div key={item.key} className="sl-social-media-item">
                      <img
                        src={iconMap[item.key] || websiteImg}
                        alt={item.key}
                        className="sl-social-icon mt-2"
                      />
                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.name || item.key}
                      </a>
                    </div>
                  ))} */}
                  {filteredData?.map((item) => {
                    const isPhone = item.key === 'business_phone';
                    const isEmail = item.key === 'business_email';

                    // const linkTarget = isPhone
                    //   ? `tel:${item.url}`
                    //   : isEmail
                    //     ? `https://mail.google.com/mail/?view=cm&to=${item.url}&subject=Hello%20There&body=I%20wanted%20to%20discuss%20an%20opportunity`
                    //     : item.url;
                

                        let linkTarget = item.url;

                        if (!isPhone && !isEmail && !/^https?:\/\//i.test(linkTarget)) {
                          linkTarget = `https://${item.url}`;
                        }
                      
                        if (isEmail) {
                          linkTarget = `https://mail.google.com/mail/?view=cm&to=${item.url}&subject=Hello%20There&body=I%20wanted%20to%20discuss%20an%20opportunity`;
                        } else if (isPhone) {
                          linkTarget = `tel:${item.url}`;
                        }
                      
                        // console.log(item.key, " -> Final URL:", linkTarget); 

                    return (
                      <a
                        href={linkTarget}
                        target={isPhone ? "_self" : "_blank"}
                        key={item.key}
                        className="sl-social-media-item"
                      >
                        <img
                          src={iconMap[item.key] || websiteImg}
                          alt={item.key}
                          className="sl-social-icon"
                        />
                        {/* <a
                          href={linkTarget}
                          target={isPhone ? "_self" : "_blank"}
                          rel="noopener noreferrer"
                        > */}
                        {item.name}
                        {/* </a> */}
                      </a>
                    );
                  })}

                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center align-items-center  my-4">
              <Link to="https://a58b43-4f.myshopify.com/" target="_blank" >
                <img src={DodLogo} height="65" width="60" />
              </Link>
              <Link to="https://a58b43-4f.myshopify.com/" target="_blank">
                <p className="p-0 m-0 text-decoration-underline text-black"> GET YOUR'S NOW FROM DOD </p>
              </Link>
            </div>
          </div>

        </div>
      </div >
    );
  }


  return (
    <>
      <ToasterContainer />

      {content}
      {Object.keys(u_Data).length !== 0 && (
        <Helmet>
          <title>{u_Data?.member_name} - Profile</title>
          <meta property="og:title" content={`${u_Data?.member_name}'s Profile`} />
          <meta property="og:description" content={`Check out ${u_Data.member_name}'s profile.`} />
          <meta property="og:image" content={`${apis?.baseurl?.Baseimageurl}${u_Data?.profile_image}`} />
          <meta property="og:url" content={`https://dodindia.in/user/${u_Data?.id}`} />
          <meta property="og:type" content="profile" />
          <meta property="og:site_name" content="DOD Profile" />
        </Helmet>
        // <Helmet>
        //   <title>{u_Data?.member_name}</title>
        //   <meta property="og:title"
        //     content={`${u_Data?.member_name}'s Business Profile`}/>
        //   <meta property="og:description"
        //     content={`Explore ${u_Data?.member_name}'s business: ${u_Data?.user_type}`}/>
        //   <meta property="og:image"
        //     content={`${apis?.baseurl?.Baseimageurl}${u_Data?.profile_image}`}/>
        //   <meta property="og:image:alt"
        //     content={`${u_Data?.member_name}'s Profile Picture`}/>
        //   <meta property="og:url" content={`https://dodindia.in/user/${id}`} />
        //   <meta property="og:type" content="website" />
        // </Helmet>
      )}

      {/* <div className="ca-card-maindiv pt-4">
        <div className="d-flex justify-content-center ">
          <div className="ca-card-main-div">
            <div>
              <img className="logo-img" src={logo} alt="logo" />
            </div>

            <div className="">
              <div className="d-flex flex-column align-items-center gap-2 gap-xl-3 user-info-div">
                <div>
                  <img
                    className="user-profile-img"
                    src={
                      u_Data?.profile_image
                        ? `${imgBaseUrl}${u_Data?.profile_image}`
                        : userAvatar
                    }
                    alt="user-profile"
                  />
                </div>
                <h3 className="user-name-text font-semibold text-white text-center mb-0">
                  {u_Data?.member_name}
                </h3>
                <h3 className="text-xl font-semibold text-white text-center m-0">
                  {u_Data?.mobile}
                </h3>
                <div>
                  <button
                    className="save-to-phone-btn"
                    onClick={handleDownloadvcfFile}>
                    Save To Phone
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex gap-3 pt-4">
                <a
                  href={`https://api.whatsapp.com/send?phone=${
                    u_Data?.whatsapp_number
                      ? u_Data?.whatsapp_number
                      : u_Data?.mobile
                  }`}
                  target="_blank"
                >
                  <img
                    className="whatsapp-logo"
                    src={whatsapplogo}
                    alt="logo1"
                  />
                </a>

                <a href={`tel:${u_Data?.mobile}`} target="_blank">
                  <img className="whatsapp-logo" src={phonelogo} alt="logo2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default CACard;
